module.exports = __webpack_public_path__ + "static/media/iconEmail.7472f223.svg";